/**
 * The JS file for the A/B testing functionality for In article donation unit in Grist.
 */
import { getCookie, setCookie } from './cookie-manager.js';

function getABTestVariant(testName) {
  let variant = getCookie(`ab_testing_${testName}`); // Check if a variant is already set in cookie

  if (!variant) {
    // If not, assign randomly (50/50 split)
    variant = Math.random() < 0.5 ? 'in_article_donation' : 'in_article_donation_new';
    setCookie(`ab_testing_${testName}`, variant, 30); // Store for 30 days
  }
  return variant;
}

// Call this early on page load
const donationVariant = getABTestVariant('in_article_donation');
// You can make this global or pass it around
window.abTestArticleDonationVariant = donationVariant;
const viewportWidth = window.innerWidth;


// Push the variant as a user property to the dataLayer if the cookie exists.
// This will make it available for the GA4 Configuration Tag.
if (donationVariant) {
  window.dataLayer = window.dataLayer || [];
  // Push the variant as a user property to the dataLayer
  // This can be useful for debugging or if you want to explicitly count variant assignments.

  var donationVariantLabel = donationVariant === 'in_article_donation' ? 'inline-a' : 'inline-b';
  window.dataLayer.push({
    'event': 'ab_test_article_donation_variant_set',
    'article_donation_ab_test_variant': donationVariantLabel // Parameter for this specific event
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const currentDonationVariant = window.abTestArticleDonationVariant; // Get the assigned variant

  // Hide all variants first (if not already hidden by default CSS).
  document.querySelectorAll('.wp-block-article-donation').forEach(el => {
    el.style.display = 'none';
  });

  // Show the assigned variant.
  const activeDonationElement = document.getElementById(`wp-block-${currentDonationVariant}`);

  // Only show if the element exists (in case of misconfiguration).
  if (activeDonationElement) {
    activeDonationElement.style.display = 'block'; // Or 'flex', 'grid' etc. based on your CSS
  }
});
